export default __webpack_public_path__ + "static/media/newLogo2.f38a29fc.png";